/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react';
import { AnimatedBackground } from 'ui/AnimatedBackground';

export const EASSpinner: FC = () => {
	return (
		// <div
		// 	style={{
		// 		display: 'flex',
		// 		alignContent: 'center',
		// 		justifyContent: 'center',
		// 		height: '100vh',
		// 		backgroundColor: '#016193',
		// 		color: '#016193',
		// 	}}
		// >
		// 	<div
		// 		style={{
		// 			height: '100vh',
		// 			width: '100vw',
		// 			display: 'flex',
		// 			justifyContent: 'center',
		// 			alignItems: 'center',
		// 		}}
		// 	>
		// 		<div style={{ height: '20vh' }}>
		// 			<img src="/img/EAS-spinner.svg" alt="" style={{ height: '100%' }} />
		// 		</div>
		// 	</div>
		// </div>
		<AnimatedBackground>
			<div
				style={{
					height: '100vh',
					width: '100vw',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<div style={{ height: '20vh', zIndex: 1000 }}>
					<img src="/img/EAS-spinner-invert.svg" alt="" style={{ height: '100%' }} />
				</div>
			</div>
		</AnimatedBackground>
	);
};
